import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import App from './app/App.js'
import storeWithToolkit from './app/redux_toolkit'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <Provider store={storeWithToolkit}>
        <App />
    </Provider>
)

// serviceWorker.unregister()
